import React from 'react';
import { connect } from 'react-redux';
import { getSocialContract, getClientDocument, getOrganizationChart } from '../../../../redux/reducers/ReferralReducer';
import SignUpReferrals from '../SignUpReferrals';
import ReferralService from '../../../../services/ReferralService';
import OrderEatCompanyStep from './OrderEatCompanyStep';
import OrderEatTermsAndConditionsStep from './OrderEatTermsAndConditionsStep';
import OrderEatLegalRepresentativeStep from './OrderEatLegalRepresentativeStep';

const OrderEatSignUpReferralsInternal = ({ clientDocument, organizationChart, socialContract, ...props }) => {
  const onSubmit = async (values) => {
    const referral = {
      data: {
        ...values.data,
        clientDocument,
        organizationChart,
        socialContract,
      },
    };
    await ReferralService.signUpOrderEatReferral(referral);
  };

  return (
    <SignUpReferrals onSubmit={onSubmit} {...props}>
      <OrderEatLegalRepresentativeStep />
      <OrderEatCompanyStep />
      <OrderEatTermsAndConditionsStep />
    </SignUpReferrals>
  );
};

const mapStateToProps = (state) => {
  return {
    clientDocument: getClientDocument(state),
    organizationChart: getOrganizationChart(state),
    socialContract: getSocialContract(state),
  };
};

export const OrderEatSignUpReferrals = connect(mapStateToProps)(OrderEatSignUpReferralsInternal);
